<div class="review-wall" [class.system]="system" *ngIf="bubbles.length" role="group" [attr.aria-label]="label" [class.moving]="moves">
  <div class="wall-col" *ngFor="let col of columns">
    <div class="wall-track">
      <app-review-card *ngFor="let r of col; trackBy: trackByReview" [review]="r"></app-review-card>
      <ng-container *ngIf="moves">
        <app-review-card *ngFor="let r of col; trackBy: trackByReview" [review]="r" aria-hidden="true"></app-review-card>
      </ng-container>
    </div>
  </div>
</div>
<!-- narrow screens: one column of every bubble -->
<div class="review-wall single" [class.system]="system" *ngIf="bubbles.length" aria-hidden="true" [class.moving]="singleMoves">
  <div class="wall-col">
    <div class="wall-track">
      <app-review-card *ngFor="let r of bubbles; trackBy: trackByReview" [review]="r"></app-review-card>
      <ng-container *ngIf="singleMoves">
        <app-review-card *ngFor="let r of bubbles; trackBy: trackByReview" [review]="r"></app-review-card>
      </ng-container>
    </div>
  </div>
</div>
